/**
 * Component for our Report showing most-exchanged-to
 * Variants.
 * 
 * @component
 */

import React from "react";
import Report from "../Report";

const columns = [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName"
  },
  {
    title: "Variant Name",
    dataIndex: "variantName",
    key: "variantName"
  },
  {
    title: "Count",
    dataIndex: "variantCount",
    key: "variantCount"
  },
];

const exportHeaders = [
  {
    label: "Product Name",
    value: "productName",
  },
  {
    label: "Variant Name",
    value: "variantName",
  },
  {
    label: "Count",
    value: "variantCount",
  },
];

class ToVariant extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Report
        url="/api/reports/exchanged-products/to-variant"
        title="Most Exchanged-To Variants"
        tooltip="This report shows how many times a variant was requested in an exchange within the selected date range."
        columns={columns}
        reportName="most-exchanged-to-variants"
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default ToVariant;
